import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import * as actions from '../actions';
import { getStatic } from '../reducers';
import Loading from '../components/Loading';
import SectionHeader from '../components/SectionHeader';
import ContactBody from './ContactBody';

class Contact extends Component {
  constructor() {
    super();
    this.links = null;
  }
  componentDidMount() {
    this.fetchData();
  }
  componentWillUnmount() { // eslint-disable-line
    document.querySelector('.main-wrapper').classList.remove('on-full');
  }

  fetchData() {
    const { fetchPage, pageId } = this.props;
    fetchPage(pageId);
  }
  render() {
    const { edition, lang, contact } = this.props;
    if (typeof edition === 'undefined' || typeof contact === 'undefined') {
      return <Loading />;
    }
    const { body } = contact;
    const style = {
      color: edition.background,
    };
    return (
      <div
        ref={(el) => { this.bodyEl = el; }}
        className="fold fold--contact fold--deco fold--main fold--main--full"
      >
        <div className="fold--main__inner">
          <section className="fold__col fold__col--main">
            <SectionHeader lang={lang} title="contact" />
            <div className="fold__col__body">
              <h2 style={style} className="field-sub-title">{lang === 'ar' ? 'مرحبا!' : 'Say Hello!'}</h2>
              <ContactBody background={edition.background} body={body} />
            </div>
          </section>
        </div>
      </div>
    );
  }
}

Contact.propTypes = {
  lang: PropTypes.string.isRequired,
  edition: PropTypes.shape({
    background: PropTypes.string,
    backgroundTextColor: PropTypes.string,
    id: PropTypes.string,
    year: PropTypes.string,
  }),
  contact: PropTypes.shape({
    body: PropTypes.string,
  }),
  fetchPage: PropTypes.func.isRequired,
  pageId: PropTypes.string.isRequired,
};

Contact.defaultProps = {
  edition: undefined,
  contact: undefined,
};


const mapStateToProps = (state, { route, lang }) => {
  const regex = lang === 'ar' ?
  /(\/:lang\/)/ : /\//;
  const pageId = route.path.replace(regex, '');
  return {
    contact: getStatic(state, pageId),
    pageId,
  };
};


Contact = connect( //eslint-disable-line
  mapStateToProps,
  actions,
)(Contact); //eslint-disable-line

export default Contact;



// WEBPACK FOOTER //
// ./js/containers/Contact.js